var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-0 pa-0"},[_c('v-row',{staticClass:"pt-0 mt-0"},[_c('v-col',{attrs:{"cols":"12"}},[_c('candidate-qualifications-form',{ref:"candidateQualificationsForm",attrs:{"read-only":_vm.readOnly}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }